export default __webpack_public_path__ + "static/media/angular.28ae4f3c.svg";